import request from '@/utils/request'

export function sendHomeMovingEmail (data) {
  // console.log('updateItem', data)
  // data.post_date = moment(data.post_date).utc().format()
  return request({
    url: '/Email/SendHomeMovingEmail',
    method: 'post',
    data
  })
}

export function sendOfficeMovingEmail (data) {
  // console.log('updateItem', data)
  // data.post_date = moment(data.post_date).utc().format()
  return request({
    url: '/Email/SendOfficeMovingEmail',
    method: 'post',
    data
  })
}
